import styled, { css } from 'styled-components';

import { grid } from '@components/Styled/mixins';

const PropertyCardHeaderWrapper = styled.section`
  ${grid()};

  grid-template-columns: 1fr;
  grid-template-rows: 1fr min-content;
  background-position: center;

  ${({ theme, thumbnail }) => css`
    border-radius: ${theme.spacing(2)} ${theme.spacing(2)} 0;
    background-image: url(${thumbnail});
    background-size: cover;
  `}
`;

export { PropertyCardHeaderWrapper };
